module.exports = __webpack_public_path__ + "static/media/fruits_52.5c5a14ed.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_52.csv
// module id = 720
// module chunks = 0